import React from 'react'
import { PageTitle } from '../../layout/core'
import ConfigurationPage from './ConfigurationPage'

const Index = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Configuration</PageTitle>
      <ConfigurationPage />
    </>
  )
}

export default Index
